import React, { useState, useRef } from 'react';
import { Helmet } from 'react-helmet-async';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: '',
    contactConsent: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const messageRef = useRef(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    // Simulate form submission (replace with actual Supabase integration)
    setTimeout(() => {
      setSubmitMessage('✓ Thank you! We will contact you within 24 hours to discuss your project.');
      setFormData({ name: '', email: '', phone: '', company: '', service: '', message: '', contactConsent: false });
      setIsSubmitting(false);
      
      setTimeout(() => {
        if (messageRef.current) {
          messageRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
    }, 1000);
  };

  return (
    <>
      <Helmet>
        <title>Contact Us - TEJ Solutions Hub</title>
        <meta name="description" content="Contact TEJ Solutions Hub for web development, mobile apps, digital marketing, and cloud solutions. Get a free consultation." />
      </Helmet>

      <div style={{ paddingTop: '100px', background: '#f9fafb', minHeight: '100vh' }}>
        <div style={{ 
          background: `
            linear-gradient(135deg, rgba(124, 58, 237, 0.85) 0%, rgba(167, 139, 250, 0.85) 100%),
            url('https://images.unsplash.com/photo-1423666639041-f56000c27a9a?w=1920&q=80')
          `,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '4rem 2rem', 
          color: 'white', 
          textAlign: 'center' 
        }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '1rem', textShadow: '0 4px 12px rgba(0,0,0,0.3)' }}>Contact Us</h1>
            <p style={{ fontSize: '1.25rem', textShadow: '0 2px 8px rgba(0,0,0,0.3)' }}>Let's discuss your project and bring your ideas to life</p>
          </div>
        </div>

        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '4rem 2rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '3rem' }}>
            {/* Contact Form */}
            <div>
              <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
                <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '2rem' }}>Get Started</h2>
                
                {submitMessage && (
                  <div 
                    ref={messageRef}
                    style={{
                      background: '#d1fae5',
                      color: '#065f46',
                      padding: '1.5rem',
                      borderRadius: '12px',
                      marginBottom: '2rem',
                      border: '2px solid #10b981',
                      fontSize: '1.1rem',
                      fontWeight: '500',
                      textAlign: 'center',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                    }}
                  >
                    {submitMessage}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151' }}>
                      Name *
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        border: '2px solid #e5e7eb',
                        borderRadius: '8px',
                        fontSize: '1rem'
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151' }}>
                      Email *
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        border: '2px solid #e5e7eb',
                        borderRadius: '8px',
                        fontSize: '1rem'
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151' }}>
                      Phone
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        border: '2px solid #e5e7eb',
                        borderRadius: '8px',
                        fontSize: '1rem'
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151' }}>
                      Company
                    </label>
                    <input
                      type="text"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        border: '2px solid #e5e7eb',
                        borderRadius: '8px',
                        fontSize: '1rem'
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151' }}>
                      Service Interested In *
                    </label>
                    <select
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      required
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        border: '2px solid #e5e7eb',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        background: 'white'
                      }}
                    >
                      <option value="">Select a service...</option>
                      <option value="web-development">Web Development</option>
                      <option value="mobile-app">Mobile App Development</option>
                      <option value="digital-marketing">Digital Marketing</option>
                      <option value="email-marketing">Email Marketing</option>
                      <option value="cloud-infrastructure">Cloud Infrastructure</option>
                      <option value="sms-marketing">SMS Marketing</option>
                      <option value="digital-campaigns">Digital Campaigns</option>
                      <option value="business-financing">Business Financing Referrals</option>
                      <option value="multiple">Multiple Services</option>
                      <option value="consultation">General Consultation</option>
                    </select>
                  </div>

                  <div style={{ marginBottom: '1.5rem' }}>
                    <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '600', color: '#374151' }}>
                      Project Details *
                    </label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="5"
                      placeholder="Tell us about your project, goals, timeline, and budget..."
                      style={{
                        width: '100%',
                        padding: '0.75rem',
                        border: '2px solid #e5e7eb',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        fontFamily: 'inherit'
                      }}
                    />
                  </div>

                  {/* Consent Checkbox */}
                  <div style={{ background: '#dbeafe', padding: '1.5rem', borderRadius: '8px', border: '2px solid #3b82f6', marginBottom: '1.5rem' }}>
                    <label style={{ display: 'flex', alignItems: 'start', cursor: 'pointer' }}>
                      <input
                        type="checkbox"
                        name="contactConsent"
                        checked={formData.contactConsent}
                        onChange={handleChange}
                        required
                        style={{
                          width: '20px',
                          height: '20px',
                          marginRight: '1rem',
                          marginTop: '0.25rem',
                          cursor: 'pointer'
                        }}
                      />
                      <span style={{ fontSize: '0.95rem', color: '#1e40af', lineHeight: '1.6' }}>
                        <strong>Contact Consent Required *</strong><br/>
                        By checking this box, I consent to be contacted by TEJ Solutions Hub via phone, email, or SMS for business consultation purposes regarding my project inquiry. I understand that:
                        <ul style={{ marginTop: '0.5rem', marginBottom: '0.5rem', paddingLeft: '1.5rem' }}>
                          <li>This is for business consultation only, not marketing</li>
                          <li>My information will not be added to marketing lists</li>
                          <li>I can request to stop contact at any time</li>
                          <li>Standard message and data rates may apply</li>
                        </ul>
                      </span>
                    </label>
                  </div>

                  <button
                    type="submit"
                    disabled={isSubmitting || !formData.contactConsent}
                    style={{
                      width: '100%',
                      padding: '1rem',
                      background: (formData.contactConsent && !isSubmitting) ? 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)' : '#d1d5db',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '1.1rem',
                      fontWeight: '600',
                      cursor: (formData.contactConsent && !isSubmitting) ? 'pointer' : 'not-allowed',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    {isSubmitting ? 'Sending...' : formData.contactConsent ? 'Send Message' : 'Please Accept Consent'}
                  </button>
                </form>
              </div>
            </div>

            {/* Contact Information */}
            <div>
              <div style={{ background: 'white', padding: '3rem', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', marginBottom: '2rem' }}>
                <h2 style={{ fontSize: '1.75rem', fontWeight: '700', color: '#7c3aed', marginBottom: '2rem' }}>Contact Information</h2>
                
                <div style={{ marginBottom: '2rem' }}>
                  <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span>📧</span> Email
                  </h3>
                  <p style={{ color: '#6b7280' }}>contact@tejsolutionshub.com</p>
                </div>

                <div style={{ marginBottom: '2rem' }}>
                  <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span>🏢</span> Address
                  </h3>
                  <p style={{ color: '#6b7280', lineHeight: '1.6' }}>
                    TEJ SUSTAINABILITY GROUP, INC.<br />
                    4273 Savannah Trce<br />
                    Atlanta, GA 30349<br />
                    United States
                  </p>
                </div>

                <div style={{ marginBottom: '2rem' }}>
                  <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span>⏰</span> Business Hours
                  </h3>
                  <p style={{ color: '#6b7280', lineHeight: '1.8' }}>
                    Monday - Friday: 9:00 AM - 6:00 PM EST<br />
                    Saturday: 10:00 AM - 2:00 PM EST<br />
                    Sunday: Closed
                  </p>
                </div>

                <div style={{ marginBottom: '2rem' }}>
                  <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span>💬</span> Response Time
                  </h3>
                  <p style={{ color: '#6b7280' }}>Typically within 24 hours</p>
                </div>

                <div>
                  <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#1f2937', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span>🆔</span> Business Information
                  </h3>
                  <p style={{ color: '#6b7280', lineHeight: '1.6' }}>
                    <strong>EIN:</strong> 86-3326707<br />
                    <strong>Founder:</strong> Zebedee McLaurin<br />
                    <strong>Established:</strong> 2020
                  </p>
                </div>
              </div>

              <div style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)', padding: '2rem', borderRadius: '12px', color: 'white', textAlign: 'center' }}>
                <h3 style={{ fontSize: '1.25rem', fontWeight: '700', marginBottom: '1rem' }}>Ready to Start?</h3>
                <p style={{ fontSize: '0.95rem', opacity: '0.95', marginBottom: '1.5rem' }}>
                  Schedule a free consultation to discuss your project
                </p>
                <a href="mailto:contact@tejsolutionshub.com" style={{
                  display: 'inline-block',
                  background: '#fbbf24',
                  color: '#1f2937',
                  padding: '0.75rem 2rem',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontWeight: '600'
                }}>
                  Email Us Now
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Privacy Notice */}
        <div style={{ background: '#fef3c7', padding: '2rem', borderTop: '2px solid #fbbf24' }}>
          <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
            <p style={{ fontSize: '1rem', color: '#92400e', fontWeight: '600', marginBottom: '0.5rem' }}>
              Privacy & Communication Notice
            </p>
            <p style={{ fontSize: '0.95rem', color: '#78350f', lineHeight: '1.6' }}>
              By submitting this form with consent, you agree to receive communications from TEJ Solutions Hub via phone, email, or SMS regarding your project inquiry and our services. We respect your privacy and comply with all applicable regulations. You can opt out at any time.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
